<template>
  <div
    v-if="loading && !notFound"
    class="progress-container text-xs-center"
  >
    <v-progress-circular
      :color="color"
      indeterminate
      size="100"
    />
  </div>
  <DataNotFound v-else-if="notFound"/>
</template>

<script>
import LoadingStateMixin from './mixins/LoadingStateMixin'
import DataNotFound from './DataNotFound'

export default {
  name: 'LoadingState',

  components: {
    DataNotFound
  },

  mixins: [ LoadingStateMixin ],

  data () {
    return {
      notFound: false
    }
  },

  mounted () {
    this.$radio.$on('api-error', ({ error }) => {
      if (this.loading && error && error.response && error.response.status === 404) {
        this.notFound = true
      }
    })
  }
}
</script>

<style scoped>
.progress-container {
  margin: 33vh auto;
}
</style>
